// @flow
import {handleActions} from 'redux-actions';
import type {LanguageKey} from '../../config/LanguageConfig';
import {changeLanguageAction} from './IntlActions';
import {fulfilled, pending} from 'bil-front-commons/lib/utils/ActionsUtils';
import {createTransform} from 'redux-persist';

//- State
export type IntlState = {
   locale?: LanguageKey,
   messages?: {[id: string]: string},
   loading: boolean,
};

export const initialState: IntlState = {
   loading: false,
};

//- Reducers
export const intl = handleActions(
   {
      [pending(changeLanguageAction)]: (state: IntlState, action: Object) => ({
         ...state,
         loading: true,
         locale: action.payload.language,
      }),
      [fulfilled(changeLanguageAction)]: (
         state: IntlState,
         action: Object,
      ) => ({
         ...state,
         loading: false,
         messages: action.payload,
      }),
   },
   initialState,
);

export const intlTransform = createTransform(
   // transform state on its way to being serialized and persisted.
   inboundState => ({
      locale: inboundState.locale,
   }),
   // transform state being re-hydrated
   outboundState => ({
      ...initialState,
      locale: outboundState.locale,
   }),
   // define which reducers this transform gets called for.
   {whitelist: ['intl']},
);
